import CTA from "../../../../components/CTA/component";
import { LINK_VARIANT } from "../../../../components/CTA/constants";

/**
 * A CTA widget
 * @param {Object} params the widget params
 *
 * Key properties of @param params object
 * @param {string} params.title title
 * @param {string} params.description description
 * @param {string} params.linkText link text
 * @param {string} params.linkUrl link url
 *
 * @returns {JSX} component structure for CTA widget
 */
function CTAWidgetContainer({ params }) {
    if (
        !params ||
        !params.title ||
        !params.description ||
        !params.linkText ||
        !params.linkUrl
    ) {
        return null;
    }
    return (
        <CTA
            text={params.title}
            description={params.description}
            linkText={params.linkText}
            linkUrl={params.linkUrl}
            external={true}
            flexPage={true}
            titleVisible={params.titleVisible}
            image={params.image}
            variant={LINK_VARIANT}
            alt={params?.image?.description}
        />
    );
}

export default CTAWidgetContainer;
